import RequestHandler from '../service/requeshandler'

export default {
    getReCAPTCHAActive: async () => {
        var response = await fetch(`applicationsettings/recaptcha/active/`, RequestHandler.createRequest('GET'));
        return await response.json();
    }
}